<template>
	<div v-if="bannerData" class="w-full !py-2 bg-black flex justify-center items-center">
		<p class="!m-0 !p-0 w-fit text-xs/[18px] max-w-[390px] md:max-w-none font-normal text-white text-center">
			<span class="pe-2">{{ message }}</span>
			<hero-banner-modal
				ref="heroModal"
				v-if="hasModal && id === 'cap_2025'"
				:auto-show="autoShow"
				:id="id"
				btn-class="text-white text-xs/[18px] underline underline-offset-2"
				:show-btn="true"
				:btn-text="cta"
			>
				<template v-slot:content-left>
					<div class="flex flex-col gap-4 justify-center h-full max-h-[360px] !py-4.5">
						<h3 class="text-center !m-0 !p-0 font-butler-light text-xl font-light uppercase">{{ title }}</h3>
						<p class="font-normal text-left text-sm !p-0 !m-0">
							Thank you for being part of our community, we couldn’t do this without you! Enjoy DOUBLE POINTS + a FREE
							gift with your purchase today as a special thank you:
						</p>
						<p class="font-bold text-left text-sm !p-0 !m-0">
							Spend {{ rewardAmountOne }} – Receive our never-before-seen Lip + Cheek shade, Jelly
						</p>
						<p class="font-normal text-left text-sm !p-0 !m-0 !-mt-3.5">
							A brand-new shade, created exclusively for you!
						</p>
						<p class="font-bold text-left text-sm !p-0 !m-0">
							Spend {{ rewardAmountTwo }} – Get Jelly + our Black Velvet Monogram Bag
						</p>
						<p class="font-normal text-left text-sm !p-0 !m-0 !-mt-3.5 italic">
							An ultra-luxe essential that perfectly holds your beauty collection.
						</p>
						<p class="font-normal text-left text-sm !p-0 !m-0">Ends July 9th, 2025 at 11:59 PM MDT.</p>
					</div>
				</template>
				<template v-slot:content-right>
					<figure role="figure" :aria-label="title">
						<img :src="capModal" :alt="title" class="w-full object-cover max-h-[320px] md:max-h-[460px]" />
					</figure>
				</template>
			</hero-banner-modal>
			<a
				v-else-if="route"
				:href="route"
				class="inline-block text-white cursor-pointer underline text-xs/[18px]"
				:aria-label="cta"
			>
				{{ cta }}
			</a>
		</p>
	</div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { useRewardsStore, useSessionStore } from '@stores'

const props = defineProps({
	bannerData: {
		type: Object,
		default: null,
	},
	isCheckout: {
		type: Boolean,
		default: false,
	},
	foundationsEndpoint: {
		type: String,
		required: true,
	},
})

const rewardsStore = useRewardsStore()
const { getRewardById } = storeToRefs(rewardsStore)

const sessionStore = useSessionStore()
const { country_code } = storeToRefs(sessionStore)

const heroModal = ref(null)
const hasModal = ref(props.bannerData?.hasModal ?? false)
const id = ref(props.bannerData?.bannerId) // id that drives rewards config
const message = ref(props.bannerData?.message)
const cta = ref(props.bannerData?.cta_label)
const route = ref(props.bannerData?.cta_route)
const capModal = ref(
	'https://s3.us-east-2.amazonaws.com/seint.com/marketing-pages/landing/cap-modal/cap-modal-image.jpg'
)

onMounted(async () => {
	const promises = [capModal.value].map((url) => {
		return new Promise((resolve) => {
			const img = new Image()
			img.src = url
			img.onload = resolve
		})
	})

	await Promise.all(promises)
})

const rewardAmountOne = computed(() => {
	if (country_code.value === 'US') {
		return '$75 USD'
	} else if (country_code.value === 'CA') {
		return '$105 CAD'
	}
	return '£79 GBP'
})
const rewardAmountTwo = computed(() => {
	if (country_code.value === 'US') {
		return '$125 USD'
	} else if (country_code.value === 'CA') {
		return '$175 CAD'
	}
	return '£132 GBP'
})

const reward = computed(() => getRewardById.value(id.value))
const autoShow = computed(() => {
	if (props.isCheckout) return false
	return props.bannerData?.autoShowModal || props.bannerData?.auto_show_info_modal
})
const title = computed(() => reward.value.modal_attributes.title)
// const description = ref(reward.value.modal_attributes.description) // not in use yet
</script>
